export default "__VITE_ASSET__HkFvwnyK__"